const NotificationService = {

  fetchAll() {
    return new Promise((resolve, reject) => {
      axios.get('notifications')
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },

  read(id) {
    return new Promise((resolve, reject) => {
      axios.patch(`notifications/${id}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },

};

export default NotificationService;
